<template>
  <div class="container">
    <div class="swiper-container-group">
      <div class="swiper-container" ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide-basic swiper-slide" v-if="isShowBasic">
            <div class="adjust-type new-version-title">基础版</div>
          </div>
          <div class="swiper-slide-higher swiper-slide">
            <div class="adjust-type  new-version-title">高级版</div>
          </div>
          <div class="swiper-slide-flag swiper-slide">
            <div class="adjust-type  new-version-title">尊享版</div>
          </div>
          <div class="swiper-slide-sport swiper-slide">
            <div class="adjust-type  new-version-title">运动版</div>
          </div>
          <div class="swiper-slide-aesthetic swiper-slide">
            <div class="adjust-type  new-version-title">美育版</div>
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <div class="back-white"></div>
      <div v-if="!isExpanded" class="bg-img">
        <template v-for="(item, index) in imgs[type]">
          <div :key="item">
            <img :src="item" alt="" />
            <div class="expand-wrap" v-if="index === 0">
              <div v-if="!isExpanded" class="expand" @click="clickExpand">展开 <img :src="downIcon" alt="" /></div>
              <div v-else class="expand" @click="clickExpand">收起 <img :src="upIcon" alt="" /></div>
            </div>
          </div>
        </template>
      </div>

      <div v-else class="bg-img">
        <div class="expand not" @click="clickExpand"></div>
        <template v-for="item in expandImgs[type]">
          <img :src="item" alt="" :key="item" />
        </template>
        <div class="expand-wrap">
          <div v-if="!isExpanded" class="expand" @click="clickExpand">展开 <img :src="downIcon" alt="" /></div>
          <div v-else class="expand" @click="clickExpand">收起 <img :src="upIcon" alt="" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'newPackage',
  props: ['isShowBasic'],
  data() {
    const t = new Date(new Date().toLocaleDateString()).getTime();
    console.log(123, t);
    return {
      type: 'basic',
      initialSlide: 1,
      isExpanded: false, // 是否展开
      downIcon: 'https://image.xiaomaiketang.com/xm/internal/Y7saA4WSY7.png',
      upIcon: 'https://image.xiaomaiketang.com/xm/internal/pyH22tENAY.png',
      left: 'https://image.xiaomaiketang.com/xm/Xe38ktyQkb.png',
      right: 'https://image.xiaomaiketang.com/xm/ZhPsZQWiYM.png',
      xmversion: null,
      imgs: {
        basic: ['https://image.xiaomaiketang.com/xm/internal/KXAxzptrja.png', 'https://image.xiaomaiketang.com/xm/internal/8FpfZz6NTF.png'],
        higher: ['https://image.xiaomaiketang.com/xm/internal/k4PdaNpniJ.png', 'https://image.xiaomaiketang.com/xm/internal/j3JisKtZPp.png'],
        flag: ['https://image.xiaomaiketang.com/xm/internal/QJfBkxAdhN.png', 'https://image.xiaomaiketang.com/xm/internal/WhyTDEw76y.png'],
        sport: ['https://image.xiaomaiketang.com/xm/internal/4WSSe7Xxxr.png', 'https://image.xiaomaiketang.com/xm/internal/XSDxpzCWx7.png'],
        aesthetic: ['https://image.xiaomaiketang.com/xm/internal/WFSQ3aKW4d.png', 'https://image.xiaomaiketang.com/xm/internal/fhMEXEDcdh.png'],
      },
      expandImgs: {
        basic: [
          'https://image.xiaomaiketang.com/xm/internal/KXAxzptrja.png',
          'https://image.xiaomaiketang.com/xm/internal/2FZx2aahQw.png',
          `https://image.xiaomaiketang.com/xm/internal/8FpfZz6NTF.png?t=${t}`,
        ],
        higher: [
          'https://image.xiaomaiketang.com/xm/internal/k4PdaNpniJ.png',
          'hhttps://image.xiaomaiketang.com/xm/internal/YxZ6QTZE2r.png',
          `https://image.xiaomaiketang.com/xm/internal/j3JisKtZPp.png?t=${t}`,
        ],
        flag: [
          'https://image.xiaomaiketang.com/xm/internal/QJfBkxAdhN.png',
          'https://image.xiaomaiketang.com/xm/internal/eHp4WXfwW8.png',
          `https://image.xiaomaiketang.com/xm/internal/WhyTDEw76y.png?t=${t}`,
        ],
        sport: [
          'https://image.xiaomaiketang.com/xm/internal/4WSSe7Xxxr.png',
          'https://image.xiaomaiketang.com/xm/internal/8JbbKMNPpD.png',
          `https://image.xiaomaiketang.com/xm/internal/XSDxpzCWx7.png?t=${t}`,
        ],
        aesthetic: [
          'https://image.xiaomaiketang.com/xm/internal/WFSQ3aKW4d.png',
          'https://image.xiaomaiketang.com/xm/internal/wPkmEWQp66.png',
          `https://image.xiaomaiketang.com/xm/internal/fhMEXEDcdh.png?t=${t}`,
        ],
      },
    };
  },
  methods: {
    init() {
      const _this = this;
      var swiper = new Swiper('.swiper-container', {
        slidesPerView: 1.16,
        spaceBetween: 8,
        centeredSlides: true,
        // initialSlide: _this.initialSlide >= 4 ? this.initialSlide - 1 : _this.initialSlide,
        initialSlide: _this.initialSlide,
        on: {
          // 动画结束后更改对应的数据
          slideChangeTransitionEnd: function() {
            const index = this.activeIndex;
            if (this.isShowBasic) {
              const newTypes = ['basic', 'higher', 'flag', 'sport', 'aesthetic'];
              _this.type = newTypes[index];
            } else {
              const newPackages = ['higher', 'flag', 'sport', 'aesthetic'];
              _this.type = newPackages[index];
            }
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    },
    // 通过URL获取当前版本
    parseUrl() {
      let No;

      // this.xmversion = window.location.hash.match(/xmversion=(\d\.\d)/)[1];
      /**
       * 3，4，5，6,7分别对应标准版，高级版，旗舰版，运动版，美育版
       */
      //高级4 尊享5 7运动 8美育
      try {
        No = window.location.hash.match(/no=(\d)/)[1];
      } catch (error) {
        No = 3;
      }
      console.log('打印的No' + No, this.isShowBasic);
      if (this.isShowBasic) {
        // this.initialSlide = ['', '', '', 0, 1, 2, 3, 4, 5][parseInt(No)];
        this.initialSlide = [parseInt(No)]-3;
      } else {
        // this.initialSlide = ['', '', '', '', 0, 1, 2, 3, 4, 5][parseInt(No)];
        const packages={
          '4':0, // 尊享
          '5':1,
          '7':2,
          '8':3,
        }
        this.initialSlide = packages[No];
      }
       console.log('打印的No' + No, this.initialSlide);
    },

    clickExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  // 判断机构是4.0还是5.0
  created() {
    this.parseUrl();
    if (this.xmversion && this.xmversion === '4.0') {
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less">
.container {
  height: 100vh;
  overflow: scroll;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #ffffff;
  .swiper-container-group {
    width: 100vw;
    height: 198px;
    padding-top: 34px;
    background: #fff3e1;
  }
  .back-white {
    width: 0;
    height: 0;
    border-top: 36px solid transparent;
    border-left: 50vw solid #ffffff;
    border-right: 50vw solid #ffffff;
    // border: 10px solid red;
    position: relative;
    top: -36px;
    z-index: 999;
  }
  .swiper-slide-basic {
    background-image: url('https://image.xiaomaiketang.com/xm/K7f3ARSWmJ.png');
    background-size: 100% 100%;
    color: #ffffff;
  }
  .swiper-slide-higher {
    background-image: url('https://image.xiaomaiketang.com/xm/FiwQTTcrd2.png');
    background-size: 100% 100%;
    color: #333333;
  }
  .swiper-slide-flag {
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/T8bk8xrGDp.png');
    background-size: 100% 100%;
    color: #ffdba8;
  }
  .swiper-slide-chain {
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/48rWdPHkeB.png');
    background-size: 100% 100%;
    color: #f7dc86;
  }
  .swiper-slide-sport {
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/internal/cSeYieTC7h.png');
    background-size: 100% 100%;
    color: #ffffff;
  }
  .swiper-slide-aesthetic {
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/internal/wYzjHdBGi4.png');
    background-size: 100% 100%;
    color: #ffffff;
  }

  .swiper-container {
    height: 195px;
    width: 100vw;
    .swiper-pagination-bullet {
      width: 5px;
      height: 5px;
      &.swiper-pagination-bullet-active {
        background: #fff;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    .adjust-type {
      width: 100%;
      height: 100%;
      font-size: 23px;
      font-weight: 500;
      text-align: center;
      justify-content: center;
      align-items: center;
      display: flex;
      font-weight: 500;
      color: #ffffff;
    }
    .new-version-title {
      width: 100%;
      height: 100%;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      //  font-size: .46rem !important;
    }
    .adjust-money {
      width: 250px;
      height: 21px;
      font-size: 17px;
      margin: auto;
      margin-top: 22px;
      font-weight: 500;
      line-height: 21px;
    }
    .adjust-money-number {
      font-size: 35px;
      font-weight: bold;
    }
    .adjusts-money {
      width: 250px;
      height: 21px;
      font-size: 17px;
      margin: auto;
      margin-top: 42px;
      font-weight: 500;
      line-height: 21px;
    }
  }
  .adjust-service-group {
    height: calc(~'100vh - 160px'); /* 计算除了轮播图的其他内容的高度 */
    .card-content {
      text-align: center;
      width: 328px;
      height: 36px;
      margin: auto;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      padding: 55px 15px 30px 15px;
      background: #ffffff;
    }
    .adjust-service-title {
      &.basic-function {
        margin-bottom: 13px;
      }
      &.branch-tasting,
      &.study-inline,
      &.add-value {
        margin-bottom: 8px;
      }
      span {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 21px;
        margin: 0 8px;
        vertical-align: middle;
      }
      img {
        width: 12px;
        height: 8px;
      }
    }
  }
  .bg-img {
    position: relative;
    font-size: 0;
    img {
      width: 100%;
    }

    .expand-wrap {
      text-align: center;
      margin-top: 0.32rem;
      padding-bottom: 0.48rem;
      .expand {
        display: inline-block;
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #999999;

        img {
          width: 0.28rem;
          line-height: 0.4rem;
          vertical-align: -0.04rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/renew/newPackage.vue